(function () {
  function init() {
    var root = document.querySelector('[data-self-reflection]');
    if (!root || root.dataset.interfaceEnhanced === 'true') return;
    root.dataset.interfaceEnhanced = 'true';
    document.body.classList.add('self-reflection-page');

    var stage = root.querySelector('[data-sr-stage]');
    var beforeControls = root.querySelector('[data-sr-before]');
    var liveControls = root.querySelector('[data-sr-live-controls]');
    var captureControls = root.querySelector('[data-sr-capture-controls]');
    if (!stage) return;

    var existingHud = root.querySelector('.self-reflection__hud');
    if (existingHud) existingHud.remove();

    var style = document.createElement('style');
    style.textContent =
      'body.self-reflection-page main#main-content{padding-top:0!important}' +
      'body.self-reflection-page .site-header,body.self-reflection-page .site-header:before,body.self-reflection-page .site-header:after{background:var(--sr-bg)!important;color:var(--sr-fg)!important}' +
      '[data-self-reflection] .self-reflection__stage-controls{position:absolute;left:50%;bottom:16px;z-index:12;width:min(calc(100% - 24px),560px);transform:translateX(-50%);pointer-events:none}' +
      '[data-self-reflection] .self-reflection__stage-controls>div:not([hidden]){display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;pointer-events:auto}' +
      '[data-self-reflection] .self-reflection__stage-controls [data-sr-before]:not([hidden]){display:block!important}' +
      '[data-self-reflection] .self-reflection__stage-controls [data-sr-before] .self-reflection__button{width:100%}' +
      '[data-self-reflection] [data-sr-stop]{display:none!important}' +
      '[data-self-reflection] .self-reflection__status,[data-self-reflection] .self-reflection__details,[data-self-reflection] .self-reflection__hud,[data-self-reflection] .self-reflection__system-code,[data-self-reflection] .self-reflection__searching{display:none!important}' +
      '[data-self-reflection] .self-reflection__panel{min-height:0!important;padding-top:24px!important;margin-top:0!important;align-content:start!important;background:var(--sr-panel-bg)!important;color:var(--sr-fg)!important}' +
      '[data-self-reflection] .self-reflection__content{min-height:0!important;padding-top:0!important;margin-top:0!important}' +
      '@media(max-width:749px),(orientation:portrait){[data-self-reflection] .self-reflection__stage-controls{bottom:max(14px,env(safe-area-inset-bottom));width:calc(100% - 24px)}[data-self-reflection] .self-reflection__panel{padding-top:18px!important}}';
    document.head.appendChild(style);

    var controls = document.createElement('div');
    controls.className = 'self-reflection__stage-controls';
    if (beforeControls) controls.appendChild(beforeControls);
    if (liveControls) controls.appendChild(liveControls);
    if (captureControls) controls.appendChild(captureControls);
    stage.appendChild(controls);

    Array.prototype.forEach.call(root.querySelectorAll('*'), function (node) {
      var text = (node.textContent || '').trim().toUpperCase();
      if (text === 'INPUT' || text === 'OUTPUT') {
        var row = node.closest('.self-reflection__meta-row,.self-reflection__row,li,tr');
        if (row) row.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
